import React from 'react';
import { Route, Routes } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import useFirebase from './containers/Firebase';
import ModalPermissionNotification from './containers/ModalPermissionNotification';
import { AuthLayout } from './Layouts/AuthLayout';
import { NonAuthLayout } from './Layouts/NonAuthLayout';
import { authProtectedRoutes, publicRoutes } from './routes/';
import AppRoute from './routes/route';

import 'styles/tailwindcss.css';

const App = () => {
  React.useEffect(() => {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DNS,
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }, []);
  useFirebase();

  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AppRoute
                layout={NonAuthLayout}
                component={route.component}
                isAuthProtected={false}
              />
            }
          />
        ))}

        {authProtectedRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AppRoute layout={AuthLayout} component={route.component} isAuthProtected={true} />
            }
          />
        ))}
      </Routes>
      <ModalPermissionNotification />
    </React.Fragment>
  );
};

export default App;
